/**
 * withCart
 * HOC for wrapping the provided component with CartProvider
 */

import React from 'react'

import CartProvider from './cart-provider'

export default function withCart (WrappedComponent) {
  return function CartProviderHOC(props) {
    return (
      <CartProvider>
        <WrappedComponent {...props} />
      </CartProvider>
    )
  }
}
